import Confirmation from '@CS/components/Popups/Confirmation';
import HomeIcon from '@CS/assets/Vector/home.svg?component';
import Button from '@CS/components/Button';
import { useState } from 'react';
import { isStaging } from '@/utils/Location';

export const CloseButton = () => {
  const confirm = location.pathname === '/editor';
  const closeConfirm = () => setVisibleConfirm(false);

  const [visibleConfirm, setVisibleConfirm] = useState(false);
  const onSubmit = () =>
    (location.href = isStaging
      ? 'https://frontend-homepage.production.mcd-uae.platform-tbwa-x.com/?fullscreen=true&appOrientation=portrait'
      : 'https://frontend-homepage.production.mcd-uae.platform-tbwa-x.com/?fullscreen=true&appOrientation=portrait');

  return (
    <>
      <Button
        onClick={(confirm && (() => setVisibleConfirm(true))) || void 0}
        link={
          (confirm ? undefined : isStaging
            ? 'https://frontend-homepage.production.mcd-uae.platform-tbwa-x.com/?fullscreen=true&appOrientation=portrait'
            : 'https://frontend-homepage.production.mcd-uae.platform-tbwa-x.com/?fullscreen=true&appOrientation=portrait')
        }
        variant="iconFill"
        style={{
          left: 'min(6.4vmin, 24px)',
          top: 'min(12.8vmin, 48px)',
          position: 'fixed',
          display: 'block',
          zIndex: '2'
        }}
      >
        <HomeIcon />
      </Button>

      {visibleConfirm && (
        <Confirmation onSubmit={onSubmit} onCancel={closeConfirm} />
      )}
    </>
  );
};
